import React from 'react'

import { CautionIcon } from '../../../src/components/elements/Icons'
import styled from '../../../src/constants/theme'

interface Props {
  htmlFor?: string
  message?: string | null
}

const FormErrorMessage: React.FC<React.PropsWithChildren<Props>> = ({
  htmlFor,
  message,
  children,
}) => {
  return message ? (
    <FormError aria-live="polite">
      <FormErrorGrid>
        <IconContainer>
          <CautionIcon />
        </IconContainer>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label
          className="errorMessage"
          dangerouslySetInnerHTML={{
            __html: message,
          }}
          htmlFor={htmlFor}
        />
        {children ? <div className="child-content">{children}</div> : null}
      </FormErrorGrid>
    </FormError>
  ) : null
}

const FormError = styled.div(({ theme }) => ({
  '#ModalContainer &': {
    marginTop: 0,
  },
  '& > div': {
    marginBottom: 0,
  },
  backgroundColor: theme.errorBackground,
  borderRadius: theme.borderRadiusSmall,
  fontSize: 12,
  fontWeight: 'bold',
  lineHeight: 14,
  margin: `${theme.padding}px 0`,
  padding: theme.paddingMobile,
}))

const FormErrorGrid = styled.div({
  '& > .child-content': {
    gridColumnStart: 2,
  },
  ul: {
    listStylePosition: 'inside',
    margin: 0,
    padding: 0,
  },
  alignItems: 'center',
  display: 'inline-grid',
  gridColumnGap: 14,
  gridRowGap: 5,
  gridTemplateColumns: 'auto auto',
})

const IconContainer = styled.div(({ theme }) => ({
  '& > svg': {
    fill: theme.errorIconDark,
  },
  gridRowEnd: 2,
}))

export default FormErrorMessage
